// extracted by mini-css-extract-plugin
export default {"root":"HorisontalLineSeparator__root__uDtwI","text":"HorisontalLineSeparator__text__GTisW"};